import { Space, Tag, Tooltip } from "antd"
import moment from "moment"
import { Button } from "src/components/actions/button"
import { PencilSvg } from "src/components/Svg"
import styled from "styled-components"

export function getColumns(onEdit) {
  return [
    {
      title: "Телефон",
      dataIndex: "phone",
      key: "phone",
      width: 50,
      sorter: (a, b) => compareText(a.phone, b.phone),
    },
    {
      title: "Номер заказа",
      dataIndex: "innerId",
      key: "innerId",
      sorter: (a, b) => compareText(a.innerId, b.innerId),
    },
    {
      title: "Дата создания",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: (a, b) => dateValue(a.createdAt) - dateValue(b.createdAt),
      render: (value) => value || "—",
    },
    {
      title: "Сумма заказа",
      dataIndex: "orderTotal",
      key: "orderTotal",
      sorter: (a, b) => (a.orderTotal ?? 0) - (b.orderTotal ?? 0),
      render: (value) => value == null ? "—" : value.toLocaleString("ru-RU", {
        style: "currency",
        currency: "RUB",
      }),
    },
    {
      title: "Точка",
      dataIndex: "pointName",
      key: "pointName",
      sorter: (a, b) => compareText(a.pointName, b.pointName),
      render: (value) => value || "—",
    },
    {
      title: "Нужно подтверждение",
      dataIndex: "isNeedAccept",
      key: "isNeedAccept",
      sorter: (a, b) => a.isNeedAccept - b.isNeedAccept,
      render: (text) => (
        <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
          {text ? "ДА" : "НЕТ"}
        </StyledTag>
      ),
    },
    {
      title: "Оплачен",
      dataIndex: "isPaid",
      key: "isPaid",
      sorter: (a, b) => a.isPaid - b.isPaid,
      render: (text) => (
        <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
          {text ? "ДА" : "НЕТ"}
        </StyledTag>
      ),
    },

    ...(onEdit ? [{
      title: "Действие",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Space size="small">
          <Tooltip placement="top" title="Редактировать" mouseLeaveDelay={0}>
            <Button size="small" type="link" onClick={() => onEdit(record.id)}>
              <PencilSvg />
            </Button>
          </Tooltip>
        </Space>
      ),
    }] : []),
  ]
}

const StyledTag = styled(Tag)`
  font-weight: 600;
  text-transform: uppercase;
`

function compareText(a, b) {
  return String(a ?? "").localeCompare(String(b ?? ""), "ru", { numeric: true })
}

function dateValue(value) {
  const date = moment(value, "DD.MM.YYYY HH:mm", true)
  return date.isValid() ? date.valueOf() : 0
}
